export enum Colors {
  Primary = 'primary',
  Default = 'default',
  Warning = 'warning',
  Success = 'success',
  Error = 'error',
  Info = 'info',
}
